import { jsx as _jsx } from "react/jsx-runtime";
import { API } from '@xbto/api-client';
import { useCallback } from 'react';
import { FlatList } from 'react-native';
import { MarketListItemBond } from './market-list-item-bond';
import { MarketListItemCrypto } from './market-list-item-crypto';
import { MarketListItemFiat } from './market-list-item-fiat';
import { MarketListItemFund } from './market-list-item-fund';
import { CurrencyIcon } from '../../molecules';
// TODO(Benoit): Integrate with mobile app (duplicate)
export function MarketList({ data, onPressAsset, assetType, getBuildEnv, }) {
    const handleRenderItem = useCallback(({ item: asset }) => {
        var _a, _b, _c, _d;
        const itemProps = {
            // TODO(Benoit): Get rid of `coinIcon`, pass primitive values instead
            coinIcon: _jsx(CurrencyIcon, { code: asset.code, getBuildEnv: getBuildEnv }),
            displayCode: asset.displayCode,
            id: asset.code,
            trending: asset.isTrending,
            onPress: onPressAsset,
        };
        if (assetType === API.MarketAssetType.Bond &&
            ((_a = asset.data) === null || _a === void 0 ? void 0 : _a.bondMarketDetail)) {
            return (_jsx(MarketListItemBond, Object.assign({}, itemProps, { data: asset.data.bondMarketDetail, description: asset.name })));
        }
        if (assetType === API.MarketAssetType.Crypto &&
            ((_b = asset.data) === null || _b === void 0 ? void 0 : _b.cryptoMarketDetail)) {
            return (_jsx(MarketListItemCrypto, Object.assign({}, itemProps, { apy: asset.apy, data: asset.data.cryptoMarketDetail, name: asset.name })));
        }
        if (assetType === API.MarketAssetType.Fiat &&
            ((_c = asset.data) === null || _c === void 0 ? void 0 : _c.fiatMarketDetail)) {
            return (_jsx(MarketListItemFiat, Object.assign({}, itemProps, { apy: asset.apy, data: asset.data.fiatMarketDetail, name: asset.name })));
        }
        if (assetType === API.MarketAssetType.Fund &&
            ((_d = asset.data) === null || _d === void 0 ? void 0 : _d.fundMarketDetail)) {
            return (_jsx(MarketListItemFund, Object.assign({}, itemProps, { apy: asset.apy, data: asset.data.fundMarketDetail, displayCode: asset.name, description: asset.valueAsOf })));
        }
        return null;
    }, [onPressAsset, assetType]);
    return (_jsx(FlatList, { keyExtractor: asset => asset.code, renderItem: handleRenderItem, data: data, showsVerticalScrollIndicator: false }));
}
